export const OnlinePaymentHistoryPageTemplate = {
    slots: ['SlbOnlinePaymentHistorySlot'],
};